import styled from "styled-components";
import { COLORS } from "@bikdotai/bik-component-library";

export const PreSalesAgentCardStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 392px;
  margin-top: 16px;
  padding: 16px;
  border: 1px solid ${COLORS.stroke.primary};
  border-radius: 8px;
  background: ${COLORS.surface.standard};

  .pre-sales-agent__row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    width: 360px;
  }
  .pre-sales-agent__content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 328px;
  }
  .pre-sales-agent__header {
    display: flex;
    flex-direction: column;
    gap: 4px;
    width: 100%;
  }
  .pre-sales-agent__title-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    /* the icon's height, so the title centres on it with the shorter switch */
    min-height: 24px;
  }
  .pre-sales-agent__configure-row {
    height: 24px;
  }
  /* The design's text chip: 12px medium in brand-800. The lib Button's xs/text
     variant renders 12px regular in brand-500, so it is styled here. */
  .pre-sales-agent__configure {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-left: -6px;
    padding: 4px 6px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16px;
    color: ${COLORS.background.inverseLight};
    cursor: pointer;
  }
`;

export const AttachedAgentChipStyled = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  width: 100%;
  padding: 8px;
  overflow: hidden;
  border-radius: 34px;
  background: ${COLORS.background.brandVeryLight};

  svg {
    flex-shrink: 0;
  }
  .attached-agent-chip__text {
    display: flex;
    flex-direction: column;
    min-width: 0;
  }
`;
